// extracted by mini-css-extract-plugin
module.exports = {"loadingWidget":"v1YvmPxyiCP6q5LVoM06X"};